import { useAppNotifications } from "@/hooks/useAppNotifications";
import { TOAST_AUTO_HIDE_DURATION } from "@/constants";
import { useAccount } from "@/context/account";
import { gql } from "@/gql";
import { showErrorToast } from "@/utils/showErrorToast";
import { useMutation } from "@apollo/client/react";

import { useTranslation } from "react-i18next";

const REQUEST_OPT_IN = gql(`
  mutation RequestOptIn($customerAccountId: ID!, $dealerAccountId: ID!) {
    requestOptIn(customerAccountId: $customerAccountId, dealerAccountId: $dealerAccountId) {
      id
      optInStatus
    }
  }
`);

type UseRequestOptInOptions = {
  successMessage?: string;
};

const useRequestOptIn = ({ successMessage }: UseRequestOptInOptions = {}) => {
  const { account } = useAccount();
  const { t } = useTranslation();

  const notifications = useAppNotifications();

  return useMutation(REQUEST_OPT_IN, {
    variables: {
      dealerAccountId: account.id,
    },
    onCompleted: () => {
      notifications.show(
        successMessage ?? t("opt_in.request.success_message"),
        {
          severity: "success",
          autoHideDuration: TOAST_AUTO_HIDE_DURATION,
        }
      );
    },
    onError: (error) => {
      showErrorToast(
        notifications,
        error,
        t("opt_in.request.error_message", { error: error.message })
      );
    },
  });
};

export { useRequestOptIn };
